import { RootState, useAppDispatch, useAppSelector } from "../../redux/AppStore";
import { updateCustomerEmail } from "../../redux/slice/UpdateTrackingAddressSlice";

export default function CustomerEmailComponent (){
  const email:string = useAppSelector((state: RootState) => state.updateAddress.newuserData.shipment_customer_email);
  const dispatch = useAppDispatch();
    return (
        <div className="UpdateVerifyInput end_width">
        <label>Email ID</label>
        <input type="email" className="form-control" placeholder="Email Id" value={email} onChange={t => 
          {
            dispatch(
              updateCustomerEmail(t.target.value),
              );
        }
            }/>
      </div>
    );

}